import React, { Component } from 'react';

import { Form } from 'antd';

class Search extends Component {
    constructor(props) {
        super(props);
    }

    onSubmit(event) {
        event.preventDefault();

        this.props.form.validateFields((error) => {
            if(!error) {
                if(typeof this.props.onSubmit === 'function') {
                    this.props.onSubmit();
                }
            }
        });
    }

    render() {
        const { children , style, classNames} = this.props;
        return (
            <div className={classNames ?  "root-search " + classNames : "root-search"} style={style || {}}>
                <Form layout="inline" onSubmit={this.onSubmit.bind(this)}>
                    { children }
                </Form>
            </div>
        )
    }
}

export default Form.create()(Search);